(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beevenom-video"] && !Shopify.designMode) return;
  try {
    
  class BeevenomVideoCard extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const unmuteButton = this.querySelector('[data-unmute]');

      if (unmuteButton && video) {
        unmuteButton.addEventListener('click', () => {
          video.muted = !video.muted;
        });
      }
    }
  }

  if (!customElements.get('beevenom-video-card')) {
    customElements.define('beevenom-video-card', BeevenomVideoCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumajo-in-action"] && !Shopify.designMode) return;
  try {
    
  class LumajoInActionCarousel extends HTMLElement {
    activeVideo = null;
    playRequestId = 0;

    connectedCallback() {
      this.scroller = this.querySelector('[data-scroller]');
      this.nextButton = this.querySelector('[data-next]');
      this.dots = Array.from(this.parentElement?.querySelectorAll('[data-dot]') || []);

      if (!this.scroller) return;

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollToNext());
        this.scroller.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
        this.updateArrowState();
      }

      const cards = Array.from(this.scroller.querySelectorAll('.lumajo-in-action-card'));
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (canHover) {
        cards.forEach((card) => {
          card.addEventListener('pointerenter', () => this.playVideo(card));
          card.addEventListener('pointerleave', () => this.pauseVideo(card));
          card.addEventListener('focusin', () => this.playVideo(card));
          card.addEventListener('focusout', () => this.pauseVideo(card));
        });
      } else if (cards.length && 'IntersectionObserver' in window) {
        const ratios = new Map();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio));

            let bestCard = null;
            let bestRatio = 0;
            cards.forEach((card) => {
              const ratio = ratios.get(card) || 0;
              if (ratio > bestRatio) {
                bestRatio = ratio;
                bestCard = card;
              }
            });

            if (bestCard && bestRatio >= 0.6) {
              const index = cards.indexOf(bestCard);
              if (index !== -1) this.setActiveDot(index);
              this.playVideo(bestCard);
            }
          },
          { root: this.scroller, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
        );
        cards.forEach((card) => observer.observe(card));
      }

      if (this.dots.length) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const target = cards[index];
            if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }
    }

    playVideo(card) {
      const video = card.querySelector('video');
      if (!video || video === this.activeVideo) return;

      this.pauseActiveVideo();
      this.activeVideo = video;

      const requestId = ++this.playRequestId;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            if (this.activeVideo !== video || requestId !== this.playRequestId) {
              video.pause();
              video.currentTime = 0;
            }
          })
          .catch(() => {});
      }
    }

    pauseVideo(card) {
      const video = card.querySelector('video');
      if (!video || video !== this.activeVideo) return;
      this.pauseActiveVideo();
    }

    pauseActiveVideo() {
      if (!this.activeVideo) return;
      const video = this.activeVideo;
      this.activeVideo = null;
      video.pause();
      video.currentTime = 0;
    }

    scrollToNext() {
      const card = this.scroller.querySelector('.lumajo-in-action-card');
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
      this.scroller.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
    }

    updateArrowState() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
      this.nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 4;
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('lumajo-in-action-carousel')) {
    customElements.define('lumajo-in-action-carousel', LumajoInActionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedalband-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pedalband-faq-accordion')) {
    class PedalbandFaqAccordion extends HTMLElement {
      connectedCallback() {
        this.questions = Array.from(this.querySelectorAll('.pedalband-faq__question'));
        this.questions.forEach((question) => {
          question.addEventListener('click', () => this.toggle(question));
        });
      }

      toggle(question) {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        this.questions.forEach((other) => other.setAttribute('aria-expanded', 'false'));
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
    }
    customElements.define('pedalband-faq-accordion', PedalbandFaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedalband-final-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pedalband-final-cta-button')) {
    class PedalbandFinalCtaButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => this.scrollToBuyBox());
      }

      scrollToBuyBox() {
        const target =
          document.querySelector('.buy-buttons-block') ||
          document.querySelector('[data-type="add-to-cart-form"]') ||
          document.querySelector('#shopify-section-main');

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
    customElements.define('pedalband-final-cta-button', PedalbandFinalCtaButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedalband-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  class PedalbandUgcCarousel extends HTMLElement {
    activeVideo = null;

    connectedCallback() {
      this.scroller = this.querySelector('[data-scroller]');
      this.dots = Array.from(this.parentElement?.querySelectorAll('[data-dot]') || []);
      this.unmuteButtons = Array.from(this.querySelectorAll('[data-unmute]'));

      if (!this.scroller) return;

      this.unmuteButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const video = button.previousElementSibling;
          if (video && video.tagName === 'VIDEO') {
            video.muted = !video.muted;
          }
        });
      });

      const cards = Array.from(this.scroller.querySelectorAll('.pedalband-ugc-videos__card'));
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (canHover) {
        cards.forEach((card) => {
          card.addEventListener('pointerenter', () => this.playVideo(card));
          card.addEventListener('pointerleave', () => this.pauseVideo(card));
          card.addEventListener('focusin', () => this.playVideo(card));
          card.addEventListener('focusout', () => this.pauseVideo(card));
        });
      } else if (cards.length && 'IntersectionObserver' in window) {
        const ratios = new Map();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio));

            let bestCard = null;
            let bestRatio = 0;
            cards.forEach((card) => {
              const ratio = ratios.get(card) || 0;
              if (ratio > bestRatio) {
                bestRatio = ratio;
                bestCard = card;
              }
            });

            if (bestCard && bestRatio >= 0.6) {
              const index = cards.indexOf(bestCard);
              if (index !== -1) this.setActiveDot(index);
              this.playVideo(bestCard);
            }
          },
          { root: this.scroller, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
        );
        cards.forEach((card) => observer.observe(card));
      }

      if (this.dots.length) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const target = cards[index];
            if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }
    }

    playVideo(card) {
      const video = card.querySelector('video');
      if (!video || video === this.activeVideo) return;

      this.pauseActiveVideo();
      this.activeVideo = video;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch(() => {});
      }
    }

    pauseVideo(card) {
      const video = card.querySelector('video');
      if (!video || video !== this.activeVideo) return;
      this.pauseActiveVideo();
    }

    pauseActiveVideo() {
      if (!this.activeVideo) return;
      const video = this.activeVideo;
      this.activeVideo = null;
      video.pause();
      video.currentTime = 0;
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('pedalband-ugc-carousel')) {
    customElements.define('pedalband-ugc-carousel', PedalbandUgcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-everything-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('everything-about-accordion')) {
    class EverythingAboutAccordion extends HTMLElement {
      connectedCallback() {
        this.questions = Array.from(this.querySelectorAll('.everything-about__question'));
        this.questions.forEach((question) => {
          question.addEventListener('click', () => this.toggle(question));
        });
      }

      toggle(question) {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        this.questions.forEach((other) => other.setAttribute('aria-expanded', 'false'));
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
    }
    customElements.define('everything-about-accordion', EverythingAboutAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-collapsible-text')) {
    class GlossyCollapsibleText extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.glossy-about__toggle');
        if (!button) return;

        button.addEventListener('click', () => {
          const collapsed = this.dataset.collapsed !== 'false';
          this.dataset.collapsed = collapsed ? 'false' : 'true';
          button.textContent = collapsed ? 'Read less' : 'Read more';
        });
      }
    }
    customElements.define('glossy-collapsible-text', GlossyCollapsibleText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-action-carousel')) {
    class GlossyActionCarousel extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[ref="track"]');
        if (!track) return;

        const arrows = Array.from(this.querySelectorAll('.glossy-action__arrow'));

        // Arrows only matter once slides overflow the track (e.g. on smaller
        // breakpoints); when every slide already fits in one row, hide them.
        const updateArrowVisibility = () => {
          const canScroll = track.scrollWidth > track.clientWidth + 1;
          arrows.forEach((arrow) => {
            arrow.style.display = canScroll ? '' : 'none';
          });
        };
        updateArrowVisibility();
        window.addEventListener('resize', updateArrowVisibility);

        arrows.forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const direction = Number(arrow.dataset.direction || 1);
            const slide = track.querySelector('.glossy-action__slide');
            const step = slide ? slide.getBoundingClientRect().width + 16 : 300;
            track.scrollBy({ left: step * direction, behavior: 'smooth' });
          });
        });

        this.querySelectorAll('.glossy-action__mute').forEach((button) => {
          button.addEventListener('click', () => {
            const video = button.closest('.glossy-action__slide')?.querySelector('video');
            if (!video) return;
            video.muted = !video.muted;
            button.dataset.muted = String(video.muted);
            button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          });
        });

        this.querySelectorAll('.glossy-action__slide-select').forEach((button) => {
          button.addEventListener('click', () => {
            const variantId = button.closest('.glossy-action__slide')?.dataset.variantId;
            if (!variantId) return;
            const input = document.querySelector(`variant-picker input[data-variant-id="${variantId}"]`);
            if (!input || input.checked) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }
    customElements.define('glossy-action-carousel', GlossyActionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-description-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-details-accordion')) {
    class GlossyDetailsAccordion extends HTMLElement {
      connectedCallback() {
        this.questions = Array.from(this.querySelectorAll('.glossy-details__question'));
        this.questions.forEach((question) => {
          question.addEventListener('click', () => this.toggle(question));
        });
      }

      toggle(question) {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        this.questions.forEach((other) => other.setAttribute('aria-expanded', 'false'));
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
    }
    customElements.define('glossy-details-accordion', GlossyDetailsAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-faq-accordion')) {
    class GlossyFaqAccordion extends HTMLElement {
      connectedCallback() {
        this.questions = Array.from(this.querySelectorAll('.glossy-faq__question'));
        this.questions.forEach((question) => {
          question.addEventListener('click', () => this.toggle(question));
        });
      }

      toggle(question) {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        this.questions.forEach((other) => other.setAttribute('aria-expanded', 'false'));
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
    }
    customElements.define('glossy-faq-accordion', GlossyFaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-hero-video')) {
    class GlossyHeroVideo extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        if (!video) return;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            this.setAttribute('data-video-blocked', '');
          });
        }
      }
    }
    customElements.define('glossy-hero-video', GlossyHeroVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glossy-related"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glossy-related-carousel')) {
    class GlossyRelatedCarousel extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[ref="track"]');
        if (!track) return;

        this.querySelectorAll('.glossy-related__arrow').forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const direction = Number(arrow.dataset.direction || 1);
            const card = track.querySelector('.glossy-related__card');
            const step = card ? card.getBoundingClientRect().width + 20 : 300;
            track.scrollBy({ left: step * direction, behavior: 'smooth' });
          });
        });
      }
    }
    customElements.define('glossy-related-carousel', GlossyRelatedCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-showcase-reveal')) {
    class ImageShowcaseReveal extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;

        this.classList.add('image-showcase--observed');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('image-showcase--visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        observer.observe(this);
      }
    }
    customElements.define('image-showcase-reveal', ImageShowcaseReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-premium-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-video-player')) {
    class PremiumVideoPlayer extends HTMLElement {
      connectedCallback() {
        const playButton = this.querySelector('.premium-video__play');
        const poster = this.querySelector('[data-poster]');
        const videoWrapper = this.querySelector('[data-video-wrapper]');

        if (!playButton || !poster || !videoWrapper) return;

        playButton.addEventListener('click', () => {
          poster.hidden = true;
          videoWrapper.hidden = false;

          const media = videoWrapper.querySelector('video, iframe');
          if (media && media.tagName === 'VIDEO') {
            media.play();
          } else if (media && media.tagName === 'IFRAME' && media.src) {
            const separator = media.src.includes('?') ? '&' : '?';
            media.src = media.src + separator + 'autoplay=1';
          }
        });
      }
    }
    customElements.define('premium-video-player', PremiumVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
